import { ORDER_PAYMENT_SET } from 'src/constants/Order';
import { IProcessingTemplates } from './DrugStoreEntity';

export interface IPaymentSetting {
  /** 货币种类 */
  currency_type: string;
  /** 收款账号 */
  payment_type?: ORDER_PAYMENT_SET;
  /** 账号 */
  account_name?: string;
  /** client id */
  client_id?: string;
  /** client secret */
  client_secret?: string;
  /** 允许医生修改药材设置 */
  allow_change_medicine_setting?: boolean;
  /** 运费价格 */
  std_freight_price?: number;
  /** 配药中心包邮价格 */
  package_price?: number;
  /** 是否允许医生记账 */
  bookkeeping_policy?: BookkeepingPolicyDict;
  // /** 配药中心是否开启草药待煎服务 */
  // decoction_enabled?: boolean;
  // /** 草药待煎服务是否必选 */
  // decoction_required?: boolean;
  // /** 代煎费用 */
  // decoction_fee?: IDecoctionFeeData;
  /** 代煎容量 */
  decoction_capacity?: number;
  /** 代煎配送范围 */
  decoction_regions?: number[];
  /** 运费模板设置 */
  freight_templates: Array<{
    template_name: string;
    freight_template_content: IFreightTemplateData[];
    medicine_group_name: string;
    is_default: boolean;
  }>;
  /** 配药中心公告 */
  notice?: string;
  /** 运费分润方: [脉景 | 配药中心] */
  express_profit_recipient?: 'macrocura' | 'seller';
  /** 快递公司code */
  express_company?: string | null;
  /** 业务类型 */
  express_type?: number | null;
  /** 面单模板 */
  express_bill_template?: number | null;
  /** 运费支付方: [脉景 | 配药中心] */
  express_payer?: 'macrocura' | 'seller';
  /** 结算方式: [现付 | 月结] */
  express_payment_type?: 'PAYG' | 'MON';
  /** 月结账号 */
  express_payment_account?: string | null;
  /** 发货人 */
  delivery_name?: string | null;
  /** 手机号 */
  delivery_mobile?: string | null;
  /** 发货地址(区县id) */
  delivery_location?: string | null;
  /** 发货详细地址 */
  delivery_address?: string | null;
  /**  是否开启加工服务 */
  processing_enabled: boolean;
  /** 必选代加工服务 */
  processing_required: boolean;
  /** 加工服务模板 */
  processing_templates: IProcessingTemplates[];
}

/**
 * 运费模板设置数据结构
 *
 * @export
 * @interface IFreightTemplateData
 */
export interface IFreightTemplateData {
  /** 配送地区（省份） */
  locations: number[];
  /** 是否包邮 */
  enable: boolean;
  /** 满多少包邮 */
  fee?: number;
  /** 首重费用 */
  fee_start: number;
  /** 首重 g */
  weight_start: number;
  /** 续重费用 */
  fee_left: number;
  /** 续重 g */
  weight_left: number;
  rowKey: string;
}

/**
 * 代煎费用数据结构
 *
 * @export
 * @interface IDecoctionFeeData
 */
export interface IDecoctionFeeData {
  /** 代煎费用 */
  fee?: number;
  /** 代煎费用单位 */
  feeUnit?: number;
}

/**
 * 快递配置
 */
export interface IExpressConfig {
  /** 快递公司名称 */
  name: string;
  /** 快递公司code */
  code: string;
  /** 业务类型列表 */
  express_types: Array<{ name: string; value: number }>;
  /** 面单模板列表 */
  express_bill_templates: Array<{ name: string; value: number }>;
  /** 脉景月结账号 */
  express_month_code: string;
}

/**
 * 上门取件时间选中回调数据结构
 */
export interface IPickUpTimeSelect {
  date: string,
  time: {
    start: number;
    end: number;

  },
  isActual: boolean,
}

/**
 * 是否允许医生记账枚举
 */
export enum BookkeepingPolicyDict {
  /** 允许 */
  All = 'ALLOW_ALL',
  /** 禁止 */
  Forbid = 'NOT_ALLOWED',
  /** 部分允许 */
  Part = 'ALLOWED_PART',
}



// WEBPACK FOOTER //
// ./src/entity/SettingEntity.ts